import { render } from "./CategoriesSelect.vue?vue&type=template&id=746fd0b1&scoped=true"
import script from "./CategoriesSelect.vue?vue&type=script&lang=js"
export * from "./CategoriesSelect.vue?vue&type=script&lang=js"

import "./CategoriesSelect.vue?vue&type=style&index=0&id=746fd0b1&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-746fd0b1"]])

export default __exports__